import { observer } from 'mobx-react-lite'
import {
  ModalDialog,
  ModalDialogActions,
  ModalDialogDescription,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogTitle,
} from '@/components/ModalDialog'
import { Button } from '@/components/Button'
import type { RemoveDependentDialogViewModel } from './RemoveDependentDialogViewModel'

export { RemoveDependentDialogViewModel } from './RemoveDependentDialogViewModel'

interface RemoveDependentDialogProps {
  vm: RemoveDependentDialogViewModel
  testId?: string
}

export const RemoveDependentDialog = observer(function RemoveDependentDialog({
  vm,
  testId,
}: RemoveDependentDialogProps) {
  return (
    <ModalDialog
      isOpen={vm.modal.showing}
      onClose={vm.closeDialog}
      isDismissable
      testId={testId}
    >
      <ModalDialogHeader>
        <ModalDialogTitle>
          Remove info about {vm.dependentName}?
        </ModalDialogTitle>
        <ModalDialogDescription>
          This will remove the dependent from this tax preparation. This action
          cannot be undone.
        </ModalDialogDescription>
      </ModalDialogHeader>
      <ModalDialogFooter sticky bordered compact>
        <ModalDialogActions>
          <Button
            label="Yes, delete"
            variant="destructive"
            onPress={vm.confirm}
            testId={testId ? `${testId}-confirm-button` : undefined}
          />
          <Button
            label="Cancel"
            variant="outline"
            onPress={vm.closeDialog}
            testId={testId ? `${testId}-cancel-button` : undefined}
          />
        </ModalDialogActions>
      </ModalDialogFooter>
    </ModalDialog>
  )
})
